/*
 * Copyright (c) Nexign, JSC, 2019-2020.
 */

/**
 * The legend styled components for Chart
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @version 1.3.1
 * @since 1.1.0
 */

import styled from 'styled-components';

import { colors, fonts } from '../../../../../theme';
import { IAttrStyled } from '../../../../../types/globalTypes';

export const ChartLegendWrapperStyled = styled.div.attrs((props: IAttrStyled) => ({
    className: `chart__legend ${props.className}`,
}))<{maxHeight: number} & IAttrStyled>`
    width: 100%;
    max-height: ${props => props.maxHeight}px;
    border-bottom: 1px solid ${colors.borderColorDisabled};
    box-sizing: border-box;
    flex-direction: column;
    flex-wrap: wrap;
    display: flex;

    .legend__item {
        position: relative;
        text-align: left;
        display: flex;
        align-items: center;
        cursor: auto;

        .legend__item-text {
            color: ${colors.textColorOpacity};
            cursor: pointer;
        }
    }

    .legend__item.checked {
        .legend__item-text {
            color: ${colors.textColor};
        }
    }

    .legend__item.disabled {
        .legend__item-text {
            color: ${colors.textColorOpacity};
            cursor: auto;
        }
    }

    &.one-item-checked {
        .legend__item.checked {
            .legend__item-text, .legend__item-marker, .legend__item-subtitle {
                cursor: auto;
            }
        }
    }

    .legend__item-subtitle {
        margin-left: 12px;
        color: ${colors.textColorOpacity};
        cursor: pointer;
    }

    .legend__item-marker {
        margin-right: 14px;
    }
`;

export const ChartLegendItemTextStyled = styled.span.attrs({
    className: 'legend__item-text',
})`
    ${fonts.textSmall};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

export const ChartLegendItemSubTitleStyled = styled.span.attrs({
    className: 'legend__item-subtitle',
})`
    ${fonts.textSmall};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;
